'use client'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/data/input'
import { TextArea } from '@/components/data/textarea'
import { Text } from '@/components/ui/text'
import { useContactForm } from './use-contact-form'

const ContactForm = () => {
  const { form, onSubmit, styles } = useContactForm()

  return (
    <div className={styles.base()}>
      <Text as="h3" size="body-lg" weight="medium" className={styles.title()}>
        Preencha o formulário e logo entraremos em contato com você
      </Text>
      <form
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}
        className={styles.form()}
      >
        <Input
          {...form.register('name')}
          label="Nome"
          placeholder="Nome"
          hideLabel
          error={form.formState.errors.name}
        />
        <Input
          {...form.register('email')}
          type="email"
          label="E-mail"
          placeholder="E-mail"
          hideLabel
          error={form.formState.errors.email}
        />
        <Input
          {...form.register('phone')}
          type="tel"
          label="Telefone"
          placeholder="Telefone"
          hideLabel
          error={form.formState.errors.phone}
        />
        <TextArea
          {...form.register('body')}
          label="Mensagem"
          placeholder="Mensagem"
          hideLabel
          rows={5}
          error={form.formState.errors.body}
        />
        <Button
          className={styles.send()}
          type="submit"
          variant="solid"
          color="primary"
          loading={form.formState.isSubmitting}
          loadingLabel="Enviando..."
          fullWidth
          uppercase
        >
          Enviar mensagem
        </Button>
      </form>
    </div>
  )
}

export default ContactForm
